import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalBorder = styled(Modal)<{ $borderRadius?: string }>`
	.ant-modal-content {
		border-radius: ${({ $borderRadius }) => $borderRadius ?? '15px'};
	}
`;
